import PdpAddToCartBtn from './PdpAddToCartBtn';
import PdpDropdownModal from './PdpDropdownModal';
import PdpMultiselectModal from './PdpMultiselectModal';

export default class PdpModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRootModifiers: this.props.data,
            selectedMenuId: this.props.selectedMenuId,
            optionGroupsMap: new Map(),
            selectedModifiers: [],
            back: false,
            backSelectedMenuIds: [],
            backSelectedMenuIndex: -1,
            tempParentGrpToCountMap: new Map(JSON.parse(JSON.stringify([...this.props.parentGrpToCountMap]))),
            multiSelectIds: this.props.accordionList,
            singleTempSelectIds: [],
            multiTempSelectIds: [],
            currentSelectionList: [],
            originalIds: [],
            finalIds: [],
            selectedComponentDisplay: "",
            selectedCategory: "",
            checkId: -1,
            substituteTempSelectIds: [],
            tempSubstituteTempSelectIds: [],
            localMultiSelectIds: this.setInitaldefaults(),
            defaultTempSelectIds: []
        };
        this.filterDropDown = this.filterDropDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.filterDropDown(this.state.selectedRootModifiers.optionGroups);
        this.getSubItemModifiers = this.getSubItemModifiers.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleMultiChange = this.handleMultiChange.bind(this);
        this.handleSingleChange = this.handleSingleChange.bind(this);
        this.saveAction = this.saveAction.bind(this);
        this.holdTempSelectedIds = this.holdTempSelectedIds.bind(this);
        this.backButtonOptionGroup = this.backButtonOptionGroup.bind(this);
        this.removeTempSelectedIds = this.removeTempSelectedIds.bind(this);
        this.populateDefaults = this.populateDefaults.bind(this);
        this.populateDefaults();

    }
    
    handleModalClose() {
        this.props.setParentGrpToCountMap(this.state.tempParentGrpToCountMap);
        //this.props.handleModalClose();
    }
    setInitaldefaults() {
        if (this.props.defaultModifiersList && this.props.defaultModifiersList.has(this.props.selectedMenuId)
            && this.props.defaultModifiersList.get(this.props.selectedMenuId).length != 0) {
            return [];
        }
        return this.props.accordionList;
    }
    populateDefaults() {
        let arrMap = [], arrId = [];
        if (this.props.defaultModifiersList && this.props.defaultModifiersList.has(this.state.selectedMenuId)
            && this.props.defaultModifiersList.get(this.state.selectedMenuId).length != 0) {
            let defData = this.props.defaultModifiersList.get(this.state.selectedMenuId);
            defData.map(val => {
                arrMap.push(val);
                this.state.localMultiSelectIds.push(val.value);
            })
            this.state.defaultTempSelectIds = defData;
        }
    }
    //Modifier MenuItemDetail.id find optiongroups
    getSubItemModifiers(modifiers, selectedMenuId) {
        modifiers.optionGroups.map(optionGroups => {
            optionGroups.Modifiers.map(optModifier => {
                if (optModifier.MenuItemDetail.Id == selectedMenuId) {
                    this.state.selectedModifiers = optModifier.optionGroups;
                } else {
                    modifiers.optionGroups.map(optionGroups => {
                        optionGroups.Modifiers.map(optModifier => {
                            return this.getSubItemModifiers(optModifier, selectedMenuId)
                        })
                    })
                }
            });
        });
    };
    setlocalMultiSelectIds(arr) {
        this.setState({ localMultiSelectIds: arr }, () => {
           //console.log(this.state.localMultiSelectIds, 'update localids');
        });
        this.state.localMultiSelectIds = arr;
    }
    getlocalMultiSelectIds() {
        return this.state.localMultiSelectIds;
    }
    //Back Arrow
    handleBack(selectedBackIndx) {
        this.state.optionGroupsMap = new Map();
        this.state.selectedModifiers = [];
        this.state.checkId = 1;
        if (this.state.backSelectedMenuIds[selectedBackIndx] != -1) {
            this.backButtonOptionGroup(this.state.selectedRootModifiers, this.state.backSelectedMenuIds[selectedBackIndx]);
            if (this.state.selectedModifiers.length > 0) {
                this.filterDropDown(this.state.selectedModifiers);
                this.state.backSelectedMenuIds.splice(-1);
                this.state.backSelectedMenuIndex = this.state.backSelectedMenuIndex - 1;
                this.state.back = true;
            }
        } else {
            this.setState({
                selectedModifiers: [], backSelectedMenuIndex: -1, back: false, selectedValue: "",
                selectedTitle: "", selectedComponentDisplay: this.props.data.ComponentDisplay
            });
            this.state.backSelectedMenuIds.splice(-1);
            this.filterDropDown(this.state.selectedRootModifiers.optionGroups);
        }
        //this.setlocalMultiSelectIds(this.state.multiSelectIds);
        if (this.state.currentSelectionList.length > 0) {
            this.setlocalMultiSelectIds(this.state.currentSelectionList);
            this.state.substituteTempSelectIds = this.state.tempSubstituteTempSelectIds
        }
        this.setState({
            multiTempSelectIds: [], singleTempSelectIds: []
        });
    }

    //Modifier MenuItemDetail.id find optiongroups
    backButtonOptionGroup(modifiers, selectedMenuId) {
        modifiers.optionGroups.some(optionGroups => {
            if (optionGroups.Id == selectedMenuId) {
                this.state.selectedTitle = modifiers.MenuItemDetail.Name;
                this.state.selectedValue = modifiers.MenuItemDetail.Id;
                this.state.selectedComponentDisplay = modifiers.ComponentDisplay;
                if ((modifiers.ComponentDisplay == 7 || modifiers.ComponentDisplay == 6) && modifiers.optionGroups.length > 0) {
                    this.state.selectedTitle = modifiers.optionGroups[0].GroupedName;
                }
                modifiers.optionGroups.map(opGroup => {
                    this.state.selectedModifiers.push(opGroup);
                })
                return true;
            } else {
                optionGroups.Modifiers.some(optModifier => {
                    return this.backButtonOptionGroup(optModifier, selectedMenuId)
                })
            }
        });
    };

    //multiple selection
    handleMultiChange(obj, max, parentId) {
        let arr = this.state.multiSelectIds;
        //const labelDisplay = obj.value + "-" + obj.label;
        let labelDisplay = {
            "id": obj.value,
            "name": obj.label,
            "baseCal": obj.baseCal,
            "price": obj.price,
            "image": obj.image,
            "componentDisplay": obj.componentDisplay
        }
        let cnt = 0;
        if (arr.indexOf(obj.value) < 0) {
            cnt = 1;
            arr.push(obj.value);
            this.props.setSelectedModifiersList(obj, this.state.selectedMenuId);
            this.props.updateTotalPrice(obj.price, "add", obj.value);
            this.props.selectedSubItems.push(labelDisplay);
        } else {
            cnt = 1;
            // Remove the children also
            let selectedChildModifiers = this.props.getAllselectedChildModifiers(obj.parentModifierId, obj.value);
            selectedChildModifiers.map((childItem) => {
                if (arr.indexOf(childItem.value) > -1) {
                    let sublabelDisplay = {
                        "id": childItem.value,
                        "name": childItem.label,
                        "baseCal": childItem.baseCal,
                        "price": childItem.price,
                        "componentDisplay": childItem.componentDisplay
                    }

                    arr.splice(arr.indexOf(childItem.value), 1);
                    this.props.updateselectedSubItems(sublabelDisplay);
                    this.props.removeSelectedModifiersList({ value: childItem.value }, null, this.state.selectedMenuId)
                    this.props.updateTotalPrice(childItem.price, "remove", childItem.value);
                }
            });
            arr.splice(arr.indexOf(obj.value), 1);
            this.props.updateselectedSubItems(labelDisplay);
            this.props.removeSelectedModifiersList({ value: obj.value }, null, this.state.selectedMenuId)
            this.props.updateTotalPrice(obj.price, "remove", obj.value);

        }
        if (cnt == 1) {
            this.setState({ multiSelectIds: arr }, () => {
            });
            this.props.handleModalSelectedIds(this.state.multiSelectIds);
        } else {
            $(".btnsWrapper .pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text("this.props.allData.MaxSelection");
        }
    }

    //onclick change value
    handleChange(value, label, type, parentId, ComponentDisplay) {
        this.state.optionGroupsMap = new Map();
        this.state.selectedModifiers = [];
        this.setState({
            selectedValue: value, selectedTitle: label, selectedComponentDisplay: ComponentDisplay, selectedCategory: parentId
        });
        
        //console.log(this.state.selectedValue, this.state.selectedTitle, "modalPage");
        this.state.selectedModifiers = [];
        this.getSubItemModifiers(this.state.selectedRootModifiers, value);
        if (this.state.selectedModifiers.length > 0) {

            this.setState({
                // singleTempSelectIds: [],// commented based on requirement to hold the single select temp ids until save action (when  click the next level selection this fails, so just commented this line - W2O7510)
                multiTempSelectIds: []
            });
            if (this.state.selectedModifiers.length > 0) {
                this.filterDropDown(this.state.selectedModifiers);
                if (this.state.backSelectedMenuIndex == -1) {
                    this.state.backSelectedMenuIds.push(-1);
                } else {
                    this.state.backSelectedMenuIds.push(parentId);
                }
                this.state.backSelectedMenuIndex = this.state.backSelectedMenuIndex + 1;
                this.state.currentSelectionList = this.state.localMultiSelectIds;
                this.state.tempSubstituteTempSelectIds = [...this.state.substituteTempSelectIds];
                this.state.tempParentGrpToCountMap = new Map(JSON.parse(JSON.stringify([...this.props.parentGrpToCountMap])));
                this.state.back = true;
            }
            $(".modal .btnWrapper")[0].scrollIntoView(0, 0);
        } else {
            if (type == 'single') {
                let obj = {
                    "id": value,
                    "name": label
                    //"baseCal": baseCal

                }
                this.handleSingleChange(obj);
            }
        }
    }

    getIndexOfSelectedValue(key) {
        let index;
        this.props.selectedSubItems.map((keyStr, indx) => {
            let id = keyStr.id/*.split("-")[0]*/
            if (id == key) {
                index = indx;
            }
        });
        return index;
    }
    //Single selection
    handleSingleChange(obj) {
        let labelDisplay = {
            "id": obj.value,
            "name": obj.label,
            "baseCal": obj.baseCal,
            "price": obj.price,
            "image": obj.image,
            "order": obj.order,
            "componentDisplay": obj.componentDisplay
        }
        let arrSingle = this.state.multiSelectIds;
        let removeObj;


        
        // Rmeove Existing selection of the dropdown
        this.props.selectedSubItems.map((keyStr, indx) => {
            let id = keyStr.id/*.split("-")[0]*/
            if (this.state.originalIds.indexOf(id) > -1 && id != obj.value) {
                removeObj = keyStr;
            }
        });
        if (removeObj && removeObj.id) {
            let x = arrSingle.indexOf(removeObj.id);
            if (x > -1) {
                arrSingle.splice(arrSingle.indexOf(removeObj.id), 1);
                this.props.updateselectedSubItems(removeObj);
                this.props.removeSelectedModifiersList({ value: removeObj.id }, null, this.state.selectedMenuId)
                this.props.updateTotalPrice(removeObj.price, "remove", removeObj.id);
            }
        }
        let indexExist = this.props.updateselectedSubItems(labelDisplay, "getindex");
        if (indexExist == -1) {
            this.props.updateselectedSubItems(labelDisplay, "add");
            this.props.setSelectedModifiersList(obj, this.state.selectedMenuId);
            this.props.updateTotalPrice(obj.price, "add", obj.value);
            arrSingle.push(obj.value);
        }

        this.setState({ multiSelectIds: arrSingle }, () => {
           //console.log(this.state.multiSelectIds, 'DropdownSelectIds222');
        });
        this.props.handleModalSelectedIds(this.state.multiSelectIds);
    }

    holdTempSelectedIds(type, obj, ids) {
        if (type == 'single') {
            this.state.originalIds = ids;
            this.state.singleTempSelectIds.push(obj);
        } else if (type == 'substitute') {
            this.state.substituteTempSelectIds.push(obj);
        } else {
            this.state.multiTempSelectIds.push(obj);
        }
    }

    // for removing segmented id
    removeTempSelectedIds(type, id) {
        let filteredSegment;
        if (type == 'multi') {
            filteredSegment = this.state.multiTempSelectIds.filter((e) => {
                if (e.value == id) {
                    return false;
                }
                return true;
            });
            this.setState({ multiTempSelectIds: filteredSegment }, () => {
                //console.log(this.state.multiTempSelectIds, 'After Delete');
            });
        }
        if (type == 'substitute') {
            filteredSegment = this.state.substituteTempSelectIds.filter((e) => {
                if (e.value == id) {
                    return false;
                }
                return true;
            });
            this.setState({ substituteTempSelectIds: filteredSegment }, () => {
                //console.log(this.state.substituteTempSelectIds, 'After Delete');
            });
        }

    }

    saveAction() {
        /*this.props.handleModalClose();*/
        var isValid = this.ValidateModalOptionSelection();
        let localMultiSelectIds = this.state.localMultiSelectIds;
        let multiSelectIds = this.state.multiSelectIds;
        if (isValid) {
            this.state.multiTempSelectIds.map(key => {
                if (!(localMultiSelectIds.indexOf(key.value) == -1 && multiSelectIds.indexOf(key.value) == -1)) {
                    this.handleMultiChange(key);
                }
            });
            this.state.substituteTempSelectIds.map(key => {
                if (!(localMultiSelectIds.indexOf(key.value) == -1 && multiSelectIds.indexOf(key.value) == -1)) {
                    this.handleMultiChange(key);
                }
            })
            this.state.defaultTempSelectIds.map(key => {
                if (!(localMultiSelectIds.indexOf(key.value) == -1 && multiSelectIds.indexOf(key.value) == -1)) {
                    this.handleMultiChange(key);
                }
            })
            this.state.singleTempSelectIds.map(key => {
                if (!(localMultiSelectIds.indexOf(key.value) == -1 && multiSelectIds.indexOf(key.value) == -1)) {
                    this.handleSingleChange(key);
                }
            });
            this.state.currentSelectionList = [];
            this.state.tempParentGrpToCountMap = new Map(JSON.parse(JSON.stringify([...this.props.parentGrpToCountMap])));
            this.state.tempSubstituteTempSelectIds = [];
            this.setState({
                multiTempSelectIds: [], singleTempSelectIds: [], substituteTempSelectIds: [], defaultTempSelectIds: []
            });
            this.props.removeDefaultModifiersList(this.state.selectedMenuId);

            return isValid;
        }
        return isValid;
    }
    ValidateModalOptionSelection() {
        var isValid = true;
        
        if ($(".multiSelect-wrapper .accordion-button.required").length > 0) {
            let errorElement = $(".multiSelect-wrapper .accordion-button.required:not(:has(.completed))");
            if (errorElement.length > 0) {
                let errorMsg = $(errorElement[0]).data("option-title");
                $(".pdpmodal-error.alert-dismissible").removeClass("hidden");
                $('.pdpmodal-error.alert-dismissible .alert-message').text("Oops! Please make the required selection '" + errorMsg + "'");
                $(".pdpmodal-error.alert-dismissible").show();
                return false;
            }
        }
        // If ComponentType 3 dropdown is present
        if ($(".multiSelect-wrapper .pdp-dropdown-option").length > 0) {
            //drop down value is not selected
            if ($(".drop-down-container.wrapper .dropdown.Option.true").length < 1) {
                $(".maxOneDropdown.Option .invalid-feedback").show();
                $(".pdpmodal-error.alert-dismissible").removeClass("hidden");
                $('.pdpmodal-error.alert-dismissible .alert-message').text("Oops! Please make a selection for ‘" + $('.maxOneDropdown.Option').attr("data-group-name") + "’");
                $(".pdpmodal-error.alert-dismissible").show();
                return false;
            }
        }
        $(".alert-dismissible").fadeOut();
        return isValid;
    }

    // filter the value
    filterDropDown(optionGroups) {
        //console.log('optionGroups --->  ', optionGroups);
        let nextOptionGroupsInternl = [];
        let optionGroupsMapV = new Map();
        this.state.optionGroupsMap = new Map();
        if (optionGroups.length > 0) {
            optionGroups.map(optionGroups => {
                let arr = [];
                optionGroups.Modifiers.map(optModifier => {
                    let optionvalue = {};
                    nextOptionGroupsInternl.push(optModifier);
                    optionvalue.label = optModifier.MenuItemDetail.Name;
                    optionvalue.value = optModifier.MenuItemDetail.Id;
                    optionvalue.ImagePath = optModifier.MenuItemDetail.ImagePath;
                    optionvalue.ModifierSlugName = optModifier.MenuItemDetail.ModifierSlugName;
                    optionvalue.BaseCalories = optModifier.MenuItemDetail.BaseCalories;
                    optionvalue.Price = optModifier.MenuItemDetail.Price;
                    optionvalue.CalcPrice = optModifier.MenuItemDetail.CalcPrice;
                    optionvalue.ComponentDisplay = optModifier.ComponentDisplay;
                    optionvalue.GroupDisplay = optionGroups.GroupDisplay;
                    optionvalue.optionGroups = optModifier.optionGroups;
                    optionvalue.IsDefault = optModifier.MenuItemDetail.IsDefault;
                    optionvalue.GroupedName = optionGroups.GroupedName;

                    if (this.state.multiSelectIds.includes(optModifier.MenuItemDetail.Id)) {
                        optionvalue.selected = "true";
                    } else {
                        optionvalue.selected = "false";
                    }
                    optModifier.optionGroups.map(optRequire => {
                        optionvalue.IsRequired = optRequire.IsRequired;
                        optionvalue.maxselects = optRequire.maxselects;
                    })
                    arr.push(optionvalue);
                })

                let key = {};
                key.Id = optionGroups.Id;
                key.name = optionGroups.Name;
                key.IsRequired = optionGroups.IsRequired;
                key.maxselects = optionGroups.maxselects
                key.minselects = optionGroups.minselects
                key.GroupDisplay = optionGroups.GroupDisplay;
                key.parentModifierId = this.state.selectedMenuId;
                optionGroupsMapV.set(key, arr);
            })
        }
        this.state.optionGroupsMap = optionGroupsMapV;

        //console.log(optionGroupsMapV, "optionGropV");
    }

    componentDidMount() {
        $(document).ready(function () {
            const modalIsOpen = $('.modal-open').length > 0;
            if (modalIsOpen) {
                $('.pdpBack').focus();
            } else {
                $('.pdpBack').blur();
            }
        });
    }

    render() {
        const { optionGroupsMap, back, backSelectedMenuIndex, multiSelectIds, selectedRootModifiers } = this.state
        let items = [];
        let itemsTitle = [];
        document.body.classList.add("modal-open");
        let firstelement = true;
        return (
            <div>
                <section className="modal">
                    <div className="innerModalWrapper">
                        <div className="btnWrapper">
                            <div className="modalBtn">
                                {back && (<button className="btn-close btn btn-circle secondary pdpBack" aria-label="Back Button" tabindex="0" onClick={() => this.handleBack(backSelectedMenuIndex)}><i className="o-icon o-icon--arrow-back-sec"></i></button>)}
                                {!back && (<button type="button" className="btn btn-circle secondary pdpBack" aria-label="Back Button" onClick={() => this.handleModalClose()}>
                                    <i className="o-icon o-icon--arrow-back-sec"></i></button>)}
                            </div>
                            <div className="modalTitle h_3">{this.state.selectedTitle || this.props.title}</div>

                        </div>
                        {
                            optionGroupsMap.forEach((k, v) => {
                                items.push(<div className="showData">
                                    <PdpMultiselectModal firstelement={firstelement} allData={this.props.allData} selectedRootModifiers={selectedRootModifiers}
                                        data={k} title={v} id={v.Id} isRequire={v.IsRequired} parentModifierId={v.parentModifierId}
                                        selectedCategory={this.state.selectedCategory}
                                        setlocalMultiSelectIds={(arr) => this.setlocalMultiSelectIds(arr)}
                                        getlocalMultiSelectIds={() => this.getlocalMultiSelectIds()}
                                        selectedoptionGroupId={this.state.selectedValue}
                                        maxSelect={v.maxselects} multiSelectIds={multiSelectIds}
                                        getAllselectedChildModifiers={(parentId, groupId, isNested) => this.props.getAllselectedChildModifiers(parentId, groupId, isNested)}
                                        parentGrpToCountMap={this.props.parentGrpToCountMap}
                                        checkMaxCount={(selectedModifierId, label, max, parentId) => this.props.checkMaxCount(selectedModifierId, label, max, parentId)}
                                        handleChange={(e, label, max, parentId, ComponentDisplay) => this.handleChange(e, label, max, parentId, ComponentDisplay)}
                                        holdTempSelectedIds={(e, label, ids) => this.holdTempSelectedIds(e, label, ids)}
                                        errorImg={this.props.errorImg}
                                        getCaloriesDetails={(modifiers, selectedArray) => this.props.getCaloriesDetails(modifiers, selectedArray)}
                                        removeSelectedModifiersList={(obj, type, mid) => this.props.removeSelectedModifiersList(obj, type, mid)}
                                        setSelectedModifiersList={(obj) => this.props.setSelectedModifiersList(obj)}
                                        CalorieAdds={this.props.CalorieAdds}
                                        CalorieAbbr={this.props.CalorieAbbr}
                                        CalorieSubtracts={this.props.CalorieSubtracts}
                                        checkTempid={(type, id) => this.checkTempid(type, id)}
                                        removeTempSelectedIds={(type, id) => this.removeTempSelectedIds(type, id)}
                                        updateTotalPrice={(price, action, id) => this.props.updateTotalPrice(price, action, id)} 
                                        selectedModifiers={this.state.localMultiSelectIds}
                                        idMaps={this.props.idMaps} displayCompNum={this.state.selectedComponentDisplay || this.props.data.ComponentDisplay} 
                                        displayCompName={ this.props.data.OptionDisplayStyle}
                                        optGrp={selectedRootModifiers.optionGroups}
                                    />
                                </div>)
                                firstelement = false;
                            })
                        }
                        <div className="showDataWrapper">

                            {items}
                        </div>
                        <div className="btnsWrapper">
                            <div className="pdp-error-display alert alert-danger alert-dismissible hidden pdpmodal-error" role="alert">
                                <span className="p1 bold alert-message"></span>
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">Dismiss</button>
                            </div>
                            <div className="saveBtnWrapper">
                                <button type="button" className="btn btn-primary btn-lg btn-save-cart" onClick={back ? () => { var x = this.saveAction(); x ? this.handleBack(backSelectedMenuIndex) : "" } : () => { var x = this.saveAction(); x ? this.props.handleModalClose() : "" }}  >Save</button>
                            </div>
                        </div>

                    </div>

                </section>
            </div>
        )
    }
}
